import { Button } from 'components';
import { RecoveryTutorPasswordForm } from 'components/Forms/Auth/RecoveryTutorPasswordForm';
import { RecoverySucess } from 'components/RecoverySuccess';
import { useQueryParams } from 'hooks/useQuery';
import { useDisclose, useError, useLoader } from 'hooks/utilHooks';
import { FC } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { recoveryPasswordValidation } from 'schemas/authValidation';
import { AuthService } from 'services';
import { IRecoveryPassword } from 'types/Auth';

import { yupResolver } from '@hookform/resolvers/yup';
import { Dialog, DialogContent } from '@mui/material';

type Props = {
  firstPassword?: boolean;
};

export const TutorRecoveryPasswordPage: FC<Props> = ({ firstPassword }) => {
  const { hideLoader, loading, showLoader } = useLoader();
  const { error, showError, hideError } = useError();
  const { isOpen, onOpen } = useDisclose();
  const { token } = useQueryParams<Pick<IRecoveryPassword, 'token'>>();

  const form = useForm<IRecoveryPassword>({
    defaultValues: {
      password: '',
      passwordConfirmation: '',
      token,
      role: 'tutor',
    },
    resolver: yupResolver(recoveryPasswordValidation),
  });

  document.title = `${firstPassword ? 'Definir senha' : 'Redefinir senha'}`;

  const onSubmit = async (values: IRecoveryPassword) => {
    try {
      showLoader();
      hideError();

      await AuthService.recoveryPasswordWithToken(values);
      onOpen();
    } catch (reason) {
      const { message } = reason as Error;
      showError(message);
    } finally {
      hideLoader();
    }
  };

  return (
    <form>
      <FormProvider {...form}>
        <RecoveryTutorPasswordForm
          error={error}
          loading={loading}
          firstPassword={firstPassword}
        >
          <Button
            fullWidth
            sx={{ mb: 2 }}
            type="submit"
            onClick={form.handleSubmit(onSubmit)}
          >
            {firstPassword ? 'Definir senha' : 'Redefinir senha'}
          </Button>
        </RecoveryTutorPasswordForm>

        <Dialog open={isOpen} maxWidth="sm" fullWidth>
          <DialogContent>
            <RecoverySucess firstPassword={firstPassword} />
          </DialogContent>
        </Dialog>
      </FormProvider>
    </form>
  );
};
